import store from '../redux/store';
import { handleJoiSchemaError, sendCloudWatchAlert } from '../utils';
import { API_DEVICE_USED_PROMO_CODE } from './api';
import { sendDeleteRequest } from './backend';

export const deleteDeviceUsedPromotion = async (
  deviceId: string,
  promoCodeKey: string
): Promise<boolean> => {
  const { companyId } = store.getState().configurationReducer;
  try {
    await sendDeleteRequest(
      API_DEVICE_USED_PROMO_CODE(companyId, deviceId, promoCodeKey)
    );
    return true;
  } catch (error) {
    sendCloudWatchAlert(
      `Failed to delete promo code (${promoCodeKey}) from device (${deviceId}) on company (${companyId}) ${handleJoiSchemaError(
        error
      )}`
    );

    return false;
  }
};
